function getActiveMaintenanceEvent(events = []) {
  const now = new Date();
  return events.find(event => {
    const startTime = new Date(event.startTime);
    const endTime = new Date(event.endTime);
    return startTime < now && endTime > now;
  });
}
export default {
  getActiveMaintenanceEvent
};